<template>
  <div class="create-team">
    <el-form
      v-loading="loading"
      :model="workRateForm"
      :rules="rules"
      ref="workRateForm"
      class="white-bg form"
      label-position="left"
      label-width="160px"
    >
      <div class="flex flex-v-center flex-h-bet">
        <h3 class="text-gray bold mt-0 mb-40">
          {{ !isEdit ? "Create" : "Edit" }} Work Rate
        </h3>
        <div class="btn-wrapper mb-10 mr-20 move-right">
          <router-link
            to="/admin/attendance/overtime/settings/work-rate"
            class="btn-back"
          >
            <span>Back</span>
          </router-link>
        </div>
      </div>

      <div class="mt-20 border">
        <el-form-item prop="group_name" label="Group Name">
          <el-input
            placeholder="Enter group name"
            v-model="workRateForm.group_name"
          ></el-input>
        </el-form-item>
        <el-form-item class="mt-30" prop="use_custom_charge" label-width="0">
          <el-radio-group
            v-model="workRateForm.use_custom_charge"
            class="mt-10"
          >
            <el-radio :label="false"
              >Do you want to compute wor rate from payroll breakdown
            </el-radio>
            <el-radio :label="true"
              >Do you want to compute work rate from custom amount</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="custom_charge"
          label="Monthly Salary"
          class="mt-30"
          v-if="workRateForm.use_custom_charge"
        >
          <el-input
            placeholder="Enter value"
            v-model="workRateForm.custom_charge"
            @keypress.native="onlyNumbers"
          ></el-input>
        </el-form-item>

        <el-form-item
          prop="payroll_charges"
          label="Monthly Salary"
          class="mt-30"
          v-if="!workRateForm.use_custom_charge"
        >
          <el-select
            v-model="workRateForm.payroll_charges"
            placeholder="Select Allowance"
            class="inline-select"
            multiple
          >
            <el-option
              v-for="item in allPayBreakdown"
              :key="item.id"
              :label="item.allowance_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div class=" mb-40">
        <h4 class="text-gray bold mt-40">Set Monthly Workdays</h4>
        <p class="small-text error" v-if="verifyMonth">
          Please set monthly workdays
        </p>
      </div>

      <div v-for="item in workRateForm.monthly_workdays" :key="item.month_id">
        <el-form-item :label="item.name" prop="days" class="mt-20">
          <el-input-number
            v-model="item.days"
            controls-position="right"
            :min="0"
            :max="item.max"
            class="month"
          ></el-input-number>
          <span class="ml-10 bold">Days</span>
        </el-form-item>
      </div>
      <div class="mt-20">
        <div class="btn-wrapper mt-20 sec-span">
          <el-button
            class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="create()"
            :loading="loading"
          >
            {{ !isEdit ? "Create" : "Save Changes" }}
          </el-button>
          <button class="btn-cancel mr-15" @click.prevent="$router.go(-1)">
            Cancel
          </button>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/attendance/overtime");
import { onlyNumbers } from "@/helpers/validation.js";

export default {
  data() {
    return {
      loading: false,
      isEdit: false,
      checkWorkdays: false,
      allowances: [],
      allPayBreakdown: [],
      workRateForm: {
        group_name: "",
        custom_charge: null,
        use_custom_charge: false,
        payroll_charges: [],
        monthly_workdays: [
          {
            name: "January",
            month_id: 1,
            days: null,
            max: 31,
          },
          {
            name: "February",
            month_id: 2,
            days: null,
            max: 29,
          },
          {
            name: "March",
            month_id: 3,
            days: null,
            max: 31,
          },
          {
            name: "April",
            month_id: 4,
            days: null,
            max: 30,
          },
          {
            name: "May",
            month_id: 5,
            days: null,
            max: 31,
          },
          {
            name: "June",
            month_id: 6,
            days: null,
            max: 30,
          },
          {
            name: "July",
            month_id: 7,
            days: null,
            max: 31,
          },
          {
            name: "August",
            month_id: 8,
            days: null,
            max: 31,
          },
          {
            name: "September",
            month_id: 9,
            days: null,
            max: 30,
          },
          {
            name: "October",
            month_id: 10,
            days: null,
            max: 31,
          },
          {
            name: "November",
            month_id: 11,
            days: null,
            max: 30,
          },
          {
            name: "December",
            month_id: 12,
            days: null,
            max: 31,
          },
        ],
      },
      rules: {
        group_name: [{ required: true, message: "Please enter group name" }],
        custom_charge: [
          { required: true, message: "Please enter monthly salary" },
        ],
        payroll_charges: [
          { required: true, message: "Please select pay break down" },
        ],
      },
    };
  },
  computed: {
    verifyMonth() {
      const checkMonth = this.workRateForm.monthly_workdays.filter(x => {
        return x.days === 0;
      });
      if (checkMonth.length === 12) {
        return !this.checkWorkdays;
      }
      return this.checkWorkdays;
    },
  },
  mounted() {
    const id = this.$route.params.id;
    this.getAllPayBreakdown();
    if (id) {
      this.fetchWorkRate(id);
    }
    this.isEdit = id ? true : false;
  },
  methods: {
    onlyNumbers,
    ...mapActions(["createWorkRate", "updateWorkRate", "getWorkRateById"]),
    fetchWorkRate(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/attendance/overtime/getWorkRateById", id)
        .then(response => {
          this.loading = false;
          const {
            group_name,
            custom_charge,
            workrateables,
            payroll_charges,
            use_custom_charge,
          } = response.data;

          const newDays = [];
          this.workRateForm.monthly_workdays.map(workrate => {
            const found = workrateables.find(
              x => x.month_id === workrate.month_id
            );
            const d = found
              ? { ...found, name: workrate.name, max: workrate.max }
              : { ...workrate, days: 0 };

            newDays.push(d);
          });

          this.workRateForm = {
            ...this.workRateForm,
            group_name,
            custom_charge: use_custom_charge ? custom_charge : null,
            monthly_workdays: newDays,
            use_custom_charge: Boolean(use_custom_charge),
            payroll_charges: use_custom_charge ? [] : payroll_charges,
          };
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getAllPayBreakdown() {
      this.$store
        .dispatch("admin/payroll/salaryManagement/getFullPayBreakdown")
        .then(response => {
          this.allPayBreakdown = response.data;
        })
        .catch(error => {
          this.$notification.error(error.message);
        });
    },
    create() {
      this.$refs[`workRateForm`].validate(valid => {
        if (valid && !this.verifyMonth) {
          this.loading = true;
          if (this.isEdit) {
            const updateFilter = this.workRateForm.monthly_workdays.filter(
              el =>
                el.days !== 0 &&
                delete el.id &&
                delete el.work_rate_id &&
                delete el.name &&
                delete el.max
            );
            const updateForm = {
              ...this.workRateForm,
              monthly_workdays: updateFilter,
            };
            const id = this.$route.params.id;
            this.$store
              .dispatch("admin/attendance/overtime/updateWorkRate", {
                data: updateForm,
                id,
              })
              .then(() => {
                this.loading = false;
                this.$router.push(
                  "/admin/attendance/overtime/settings/work-rate"
                );
              })
              .catch(() => {
                this.loading = false;
              });
            return;
          } else {
            const filtered = this.workRateForm.monthly_workdays.filter(
              el => el.days !== 0 && delete el.name && delete el.max
            );
            const inputData = {
              ...this.workRateForm,
              monthly_workdays: filtered,
            };

            this.$store
              .dispatch("admin/attendance/overtime/createWorkRate", inputData)
              .then(() => {
                this.loading = false;
                this.$router.push(
                  "/admin/attendance/overtime/settings/work-rate"
                );
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.month.el-input-number .el-input-number__decrease,
.month.el-input-number .el-input-number__increase {
  background-color: #ffffff !important;
  color: #888888 !important;
}

.el-input-number__decrease {
  background-color: #ffffff !important;
}

.error {
  color: #ed6363;
}
</style>
